export const SET_SHOW_DESTAJOS = "SET_SHOW_DESTAJOS";
export const SET_SHOW_SUBDESTAJOS = "SET_SHOW_SUBDESTAJOS";
export const TOGGLE_PARTIDA = "TOGGLE_PARTIDA";
export const TOGGLE_DESTAJO = "TOGGLE_DESTAJO";
